import { Tooltip } from '@chakra-ui/react';
import { ShareStatus } from '@common/graphql/generated';
import { PAGE_MODE_MINE_COLOR } from '@common/react/pageMode';
import { Eye, EyeOff } from './icons';
import Toggle from './Toggle';

export interface ShareStatusToggleProps {
    shareStatus: ShareStatus;
    onChangeShareStatus: (shareStatus: ShareStatus) => void;
    isDisabled?: boolean;
}

const ShareStatusToggle = ({
    shareStatus,
    onChangeShareStatus,
    isDisabled,
}: ShareStatusToggleProps) => {
    return (
        <Tooltip
            placement="top"
            label={shareStatus === 'SHARED' ? 'Visible to partner' : 'Private'}
        >
            <div>
                <Toggle
                    size="sm"
                    showUnselectedIcon={false}
                    value={shareStatus}
                    onChanged={(v) => {
                        onChangeShareStatus(v);
                    }}
                    options={[
                        {
                            value: 'SHARED',
                            el: <Eye size="sm" />,
                            selectedBg: 'gray.200',
                            isDisabled,
                        },
                        {
                            value: 'PRIVATE',
                            el: <EyeOff size="sm" />,
                            selectedBg: PAGE_MODE_MINE_COLOR,
                            isDisabled,
                        },
                    ]}
                />
            </div>
        </Tooltip>
    );
};

export default ShareStatusToggle;
